import { IntegrationRetail } from "../models";


export const INTEGRATION_REATILS: IntegrationRetail[] = [
    {
        id: 'kaspi',
        name: {
            ru: 'Каспи',
            en: 'Kaspi',
            kz: 'Каспи'
        }
    },
    {
        id: 'ozon',
        name: {
            ru: 'Озон',
            en: 'Ozon',
            kz: 'Озон'
        }
    },
    {
        id: 'marking',
        name: {
            ru: 'Маркировка',
            en: 'Marking',
            kz: 'Маркировка'
        }
    },
    {
        id: 'public-api',
        name: {
            ru: 'Апи',
            en: 'Api',
            kz: 'Апи'
        }
    },
    {
        id: 'orgs',
        name: {
            ru: 'Интеграция между организациями',
            en: 'Organization integration',
            kz: 'Интеграция между организациями'
        }
    },
    {
        id: 'metro',
        name: {
            ru: 'Метро',
            en: 'Metro',
            kz: 'Метро'
        }
    }
];

export const INTEGRATION_REATILS_FOR_EXPORT: IntegrationRetail[] = [
    {
        id: 'kaspi',
        name: {
            ru: 'Каспи',
            en: 'Kaspi',
            kz: 'Каспи'
        }
    },
    {
        id: 'ozon',
        name: {
            ru: 'Озон',
            en: 'Ozon',
            kz: 'Озон'
        }
    },
    {
        id: 'marking',
        name: {
            ru: 'Маркировка',
            en: 'Marking',
            kz: 'Маркировка'
        }
    }
];